import { Text } from "../../../shared/uiComponents";
import { BtDashboardSummary } from "../../../redux/State/clientSlice/dashboardSlice";
import {
  SummaryCheckCircleSvg,
  SummaryClockCircleSvg,
  SummaryBarChartSvg,
} from "../../../shared/Assets/svgIcons";

interface SummaryCardsProps {
  summary: BtDashboardSummary | null;
}

const SummaryCards = ({ summary }: SummaryCardsProps) => {
  const cards = [
    {
      label: "Sessions Completed",
      value: `${summary?.sessionsCompletedThisWeek ?? 0} / ${summary?.sessionsScheduledThisWeek ?? 0}`,
      subtitle: summary?.sessionsMissedThisWeek ? `${summary.sessionsMissedThisWeek} missed` : "This week",
      icon: <SummaryCheckCircleSvg />,
      iconClass: "btSummaryIconGreen",
      accentClass: "btSummaryCardAccentTeal",
    },
    {
      label: "Hours Worked",
      value: summary?.hoursWorkedThisWeek ?? 0,
      subtitle: "This week",
      icon: <SummaryClockCircleSvg />,
      iconClass: "btSummaryIconOrange",
      accentClass: "btSummaryCardAccentOrange",
    },
    {
      label: "Targets Improving",
      value: summary?.targetsImproving ?? 0,
      subtitle: "Across all clients",
      icon: <SummaryBarChartSvg />,
      iconClass: "btSummaryIconPrimary",
      accentClass: "btSummaryCardAccentGreen",
    },
  ];

  return (
    <div className="btSummaryCards">
      {cards.map((card, index) => (
        <div className={`btSummaryCard ${card.accentClass}`} key={index}>
          <div className="btSummaryCardHeader">
            <div className={`btSummaryIcon ${card.iconClass}`}>
              {card.icon}
            </div>
            <Text className="btSummaryValue" title={String(card.value)} type="h2" font="header" fontWeight="semiBold" />
          </div>
          <Text className="btSummaryLabel" title={card.label} type="psm" fontWeight="medium" />
          <Text className="btSummarySubtitle" title={card.subtitle} type="pxs" />
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
